import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Mic, Sparkles } from "lucide-react";

export const Navbar = ({ showCreate = true }) => {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 glass border-b border-white/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <div className="relative h-9 w-9 rounded-lg bg-gradient-to-br from-[#22C55E] to-[#3B82F6] flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-[#0F1117]" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg font-bold text-[#F8FAFC]">Innovate Flow</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#94A3B8] -mt-0.5">Studio</div>
          </div>
        </Link>

        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-2 text-xs text-[#94A3B8]">
            <span className="h-2 w-2 rounded-full bg-[#22C55E] pulse-glow" />
            Wispr Flow online
          </div>
          {showCreate && (
            <Button
              data-testid="nav-new-project-btn"
              onClick={() => navigate("/create")}
              className="bg-[#22C55E] hover:bg-[#16A34A] text-[#0F1117] font-semibold rounded-full px-5 transition-all hover:scale-[1.03]"
            >
              <Mic className="h-4 w-4 mr-2" /> New Project
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
